import React from 'react';
import { Typography } from 'fronton-react';
import { patchUrlByLocale } from 'utils';
import { StoreStockData } from './types';
import { stockInStoresTitleText, stockInStoresTitleContainer } from './styles';
import { createStoreLink } from './utils/create-store-link';

export type TitleNonInteractiveProps = {
  availableStore: StoreStockData | null;
  regionCode: string;
  stocks: StoreStockData[];
};

export const TitleNonInteractive: React.FC<TitleNonInteractiveProps> = ({
  availableStore,
  regionCode,
  stocks,
}) => {
  const url = patchUrlByLocale(createStoreLink(regionCode, stocks) as string);
  return (
    <a className={stockInStoresTitleContainer} data-qa="stock-in-stores-title-non-interactive" href={url}>
      <Typography className={stockInStoresTitleText} color="control-primary" size="body_accent" variant="s">
        {availableStore?.storeFullName}
      </Typography>
      <Typography className={stockInStoresTitleText} color="control-primary" size="body_long" variant="s">
        {`${availableStore?.stockValue} ${availableStore?.stockUnit}`}
      </Typography>
    </a>
  );
};
